let lat = false;
let lng = false;
let supportsGeoLocation = 'geolocation' in navigator;

let opts = {
  get() {
    return { lat, lng };
  },

  query() {
    if (!supportsGeoLocation) {
      return;
    }

    navigator.geolocation.getCurrentPosition(
      function success(position) {
        lat = position.coords.latitude;
        lng = position.coords.longitude;

        window.PubSub.publish('user:location', { lat, lng });
      },

      function error(message) {
        // eslint-disable-next-line
        console.error(`[Marden's] - error loading user's position: ${message}`);
      }
    )
  },

  set(newLat, newLng) {
    lat = newLat;
    lng = newLng;
  },
};

export default opts;



// WEBPACK FOOTER //
// ./scripts/lib/get-user-location.js